import dayjs from "dayjs";
import { state } from "../../../interfaces/interfaces";
import { ExtUser } from "@services/authorizationService";
import subscriptions from "@services/subscriptions/instance";
import { serviceManager } from "@services/workers";

subscriptions.subscribe("User", "Home", (user: ExtUser) => {
  if (user) { 
    // check if access token is expired
    if (user.expires_at) { // if user.expires_at is null, then user is not logged in
      const now = dayjs().valueOf(); // current time in milliseconds
      const expiresAt = dayjs(user.expires_at * 1000).valueOf(); // convert to milliseconds
      if (now > expiresAt) { // access token is expired
        state.IsAuthenticated = false; // set state to false
        stopCacheAndBookingSync(); // stop cache and booking sync
        return; // return
      }
    }

    state.UserId = Number(user.profile.user_id); // set user id

    serviceManager.sendMessageToWorker({ 
      serviceName: "BOOKING_DATA_SYNC",
      serviceData: {
        origin: "MAIN_THREAD",
        command: "SET_USER_ID",
        payload: Number(user.profile.user_id),
      }
    });
    serviceManager.sendMessageToWorker({
      serviceName: "WEBSOCKET_SYNC",
      serviceData: {
        origin: "MAIN_THREAD",
        command: "SET_USER_ID",
        payload: Number(user.profile.user_id),
      }
    });
    serviceManager.sendMessageToWorker({
      serviceName: "LOG_SYNC",
      serviceData: {
        origin: "MAIN_THREAD",
        command: "SET_USER_ID",
        payload: Number(user.profile.user_id),
      }
    });

    if (user.profile?.puzzel) { // if user has access to puzzel
      const puzzel = JSON.parse(user.profile.puzzel); // parse puzzel
 
      serviceManager.sendMessageToWorker({ // send puzzel credentials to worker
        serviceName: "PUZZEL_SYNC",
        serviceData: {
          origin: "MAIN_THREAD",
          command: "SET_CREDENTIALS",
          payload: puzzel,
        },
      });
    }

    serviceManager.startService("PUZZEL_SYNC"); // start puzzel sync

    serviceManager.sendMessageToWorker({ 
      serviceName: "BOOKING_DATA_SYNC",
      serviceData: {
        origin: "MAIN_THREAD",
        command: "SET_USER",
        payload: user,
      }
    });

    serviceManager.sendMessageToWorker({
      serviceName: "LOG_SYNC",
      serviceData: {
        origin: "MAIN_THREAD",
        command: "SET_USER",
        payload: user,
      }
    });
    serviceManager.sendMessageToWorker({
      serviceName: "CACHE_SYNC",
      serviceData: {
        command: "SET_USER",
        origin: "MAIN_THREAD",
        payload: user,
      },
    });
    startCacheAndBookingSync(); // start cache and booking sync
  } else {
    // cancel booking sync if user is not logged in
    // cancel cache sync if user is not logged in
    stopCacheAndBookingSync(); // stop cache and booking sync
  }
});

export const subscribe = () => {
  startCacheAndBookingSync();
};

export const unsubscribe = () => {
  // cancel booking sync on home unmount
  // cancel cache sync on home unmount
  stopCacheAndBookingSync();
};

const startCacheAndBookingSync = () => {
  setTimeout(() => {
    if (window.location.pathname === "/") {
      // little delay to prevent throttling in postMessage for workers (value of 75 ms)
      serviceManager.startService("BOOKING_DATA_SYNC");
      // only if current location is home
      serviceManager.startService("CACHE_SYNC");
    }
  }, 100); // 100 ms delay
};

export const stopCacheAndBookingSync = () => {
  // cancel booking sync if user is not logged in or unmount
  serviceManager.stopService("BOOKING_DATA_SYNC");
  // cancel cache sync if user is not logged in or unmount
  serviceManager.stopService("CACHE_SYNC");
};
